import React, {useState} from "react";
import {useTranslation} from "next-i18next";
import Inputs from "./inputs";

/**
 *
 * @param data
 */
function initData(data) {
    let nutrientsWithChildren = [];

    // add the children to the same level as the parents
    data.map(nutrient => {
        nutrientsWithChildren.push(nutrient);
        if(!nutrient.children) return;
        nutrient.children.map(child => {
            nutrientsWithChildren.push(child);
            if(!child.children) return;
            child.children.map(childrenChild => {
                nutrientsWithChildren.push(childrenChild);
            });
        });
    });

    // remove 'not specified'
    nutrientsWithChildren = removeFromData(nutrientsWithChildren, '42');

    // add a blank one
    return addBlankData(nutrientsWithChildren);
}

/**
 *
 * @param data
 * @param id
 */
function removeFromData(data, id) {
   return data.filter(item => item.id !== id);
}

/**
 *
 * @param data
 * @returns {*}
 */
function addBlankData(data) {
    return [...data, {'id': 'nutrient-' + Date.now().toString(), 'name': '', 'translation': '', 'proportion': '', 'children': []}];
}

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function List ({ nutrients })
{
    // init
    const { t } = useTranslation();
    const [nutrientData, setNutrientData] = useState(
        initData(nutrients)
    );

    /**
     *
     * @param event
     */
    function addNutrient(event) {
        event.preventDefault();
        event.target.blur();
        setNutrientData(
            nutrientData => addBlankData(nutrientData)
        );
    }

    /**
     *
     * @param event
     */
    function removeNutrient(event) {
        event.preventDefault();
        event.target.blur();

        // reduce the nutrient-data by filtering out this id
        const id = event.target.getAttribute('data-eqno-nutrient-id');
        setNutrientData(
            nutrientData => removeFromData(nutrientData, id)
        );
    }

    // render
    return (
        <>
            {/* Labels */}
            <div className="row justify-content-center justify-content-lg-start">
                <div className="mb-1 col-7 col-sm-7 col-md-6 col-lg-5 col-xl-4">
                    <label htmlFor="nutrient">{t('nutrient')}</label>
                </div>
                <div className="mb-1 col-3 col-sm-3 col-md-2">
                    <label htmlFor="nutrientPercentage">{t('proportion')}</label>
                </div>
                <div className="mb-1 col-2 col-sm-2 col-md-1">
                    <label className="text-center" htmlFor="moreNutrients">{t('more')}</label>
                </div>
            </div>

            {/* Nutrients */}
            {nutrientData.map((nutrient, index) =>
                <Inputs
                    key={'nutrient-' + nutrient.id + '-' + index}
                    nutrient={nutrient}
                    addNutrientCallback={addNutrient}
                    removeNutrientCallback={removeNutrient}
                    more={index === (nutrientData.length - 1)}
                />
            )}
        </>
    );
}